import { MenuItem } from "./MenuItem";
import { MenuItemTranslation } from "./Translation";

export interface DailyCount {
    date: string; // YYYY-MM-DD
    count: number;
}

export interface DailyScreenViews {
    last7days: DailyCount[];
    last30days: DailyCount[];
    prev7days?: DailyCount[];
    prev30days?: DailyCount[];
}

export interface HourlyCount {
    hour: number; // 0-23
    count: number;
}

export interface HourlyViews {
    last7days: HourlyCount[];
    last30days: HourlyCount[];
}

export interface UtmSource {
    source: string;
    count: number;
}

export interface UtmSources {
    last7days: UtmSource[];
    last30days: UtmSource[];
}

export interface MenuItemClick {
    item_id: string;
    item?: MenuItem;
    count: number;
}

export interface MenuItemClicks {
    last7days: MenuItemClick[];
    last30days: MenuItemClick[];
}

export interface TrendSummary {
    likes: number;
    dislikes: number;
}

export interface MenuItemStats {
    menuItemId: number;
    translations: MenuItemTranslation[];
    likeCount: number;
    dislikeCount: number;
    trend7: TrendSummary;
    trend30: TrendSummary;
}

export function parseMenuItemStats(raw: any[]): MenuItemStats[] {
    return raw.map((item): MenuItemStats => ({
        menuItemId: Number(item.menuItemId),
        translations: item.translations ?? [],
        likeCount: Number(item.likeCount),
        dislikeCount: Number(item.dislikeCount),
        trend7: {
            likes: Number(item.trend7?.likes || 0),
            dislikes: Number(item.trend7?.dislikes || 0),
        },
        trend30: {
            likes: Number(item.trend30?.likes || 0),
            dislikes: Number(item.trend30?.dislikes || 0),
        },
    }));
}